var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.4001C12.4418 6.4001 12.8 6.75827 12.8 7.2001V12.0001C12.8 13.3256 11.7255 14.4001 10.4 14.4001H5.59999C4.27451 14.4001 3.19999 13.3256 3.19999 12.0001V7.2001C3.19999 6.75827 3.55817 6.4001 3.99999 6.4001H12ZM11.2 8.0001H4.79999V12.0001C4.79999 12.4419 5.15817 12.8001 5.59999 12.8001H10.4C10.8418 12.8001 11.2 12.4419 11.2 12.0001V8.0001ZM5.59999 2.4001C5.59999 1.95827 5.95817 1.6001 6.39999 1.6001H9.59999C10.0418 1.6001 10.4 1.95827 10.4 2.4001V3.2001H12.8C13.2418 3.2001 13.6 3.55827 13.6 4.0001C13.6 4.44193 13.2418 4.8001 12.8 4.8001H3.19999C2.75817 4.8001 2.39999 4.44193 2.39999 4.0001C2.39999 3.55827 2.75817 3.2001 3.19999 3.2001H5.59999V2.4001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.50c130d4531809de8ab57696db321274.svg";
export { ForwardRef as ReactComponent };